import React from 'react';

import { ViewAppIdIcon } from 'components/commonAssets';
import { _I_ } from 'components/translate';
import { BootButton } from 'generics/buttons';

// LogStream.enable( "VIEWMARKETEDITEMSLIST" );

export class ViewAchievementAppFilterEditor extends React.Component  {
  constructor( props )  {
    super( props );
    this.state = {
    };
  }

  renderAppEntry( appId )  {
    const onSwitch = ()  => this.props.onUpdate(appId);

    return (
        <BootButton  key={appId}  active  onClick={onSwitch}  >
            <ViewAppIdIcon appId={appId} compact />
        </BootButton>
      );

  }


  renderAppList()  {
    return (
        <div className="appid-filter-menu">
          <div className="appid-filter-menu-label">
            {_I_("AppFilterEditor.label.byTitles")}
          </div>
          <div className="appid-filter-menu-list">
            {this.props.appIds.map(  (appId) => this.renderAppEntry(appId)  )}
          </div>
        </div>
      );
  }

  render()  {
    return this.renderAppList();
  }
}
